module.exports = __webpack_public_path__ + "img/card-icon.e181945.png";